module.exports = __webpack_public_path__ + "assets/adobe-client-data-layer.afbde1db.svg";